<template>
  <div v-if="detail.id">
    <el-row>
      <el-col :span="12">
        <oms-row label="规格" :span="8" v-if="detail.specifications">
          {{detail.specifications}}
        </oms-row>
        <oms-row label="货品编号" :span="8" v-if="detail.code">
          {{detail.code}}
        </oms-row>
        <oms-row label="剂型" :span="8" v-if="detail.dosageForm">
          <dict :dict-group="'dosageForm'" :dict-key="detail.dosageForm"></dict>
        </oms-row>
        <oms-row label="进口注册证号" :span="8" v-if="detail.registrationNumber">
          {{detail.registrationNumber}}
        </oms-row>
        <oms-row label="生产厂商" :span="8">
          {{detail.factoryName}}
        </oms-row>
      </el-col>
      <el-col :span="12">
        <oms-row label="批准文号" :span="8" v-if="detail.approvalNumber">
          {{detail.approvalNumber}}
        </oms-row>
        <oms-row label="国家或地区" :span="8" v-if="detail.origin">
          {{detail.origin}}
        </oms-row>
        <oms-row label="最小赋码单位所含最小计价单位数量" :span="8" v-if="detail.minTagUnitCount">
          {{detail.minTagUnitCount}}
        </oms-row>
        <oms-row label="包装规格" :span="8" v-if="detail.packingSpecification">
          {{detail.packingSpecification}}
        </oms-row>
      </el-col>
    </el-row>
  </div>
</template>
<script>
  export default {
    name: 'GoodsInfoPart',
    props: {
      detail: {
        type: Object,
        default: () => {}
      }
    }
  };
</script>
